import { Link } from "react-router-dom";
import InlineNewsletterSignup from "@/components/InlineNewsletterSignup";

interface FooterLegalBarProps {
  year: number;
}

const FooterLegalBar = ({ year }: FooterLegalBarProps) => {
  return (
    <div className="border-t border-border bg-background/60">
      <div className="container mx-auto px-4 py-3 flex flex-col md:flex-row md:items-center gap-3 md:gap-4 text-[11px] font-mono text-muted-foreground/80">
        <div className="flex flex-row flex-wrap items-center gap-x-2 gap-y-1">
          <span>© {year} HackerLabs.ai</span>
          <span className="text-muted-foreground/40">·</span>
          <Link to="/privacy" className="hover:text-foreground transition-colors">
            Privacy
          </Link>
          <span className="text-muted-foreground/40">·</span>
          <Link to="/terms" className="hover:text-foreground transition-colors">
            Terms
          </Link>
          <span className="text-muted-foreground/40">·</span>
          <Link to="/feedback" className="hover:text-foreground transition-colors">
            Feedback
          </Link>
          <span className="text-muted-foreground/40">·</span>
          <Link to="/affiliate-disclosure" className="hover:text-foreground transition-colors">
            Affiliate
          </Link>
          <span className="text-muted-foreground/40">·</span>
          <Link to="/legal" className="hover:text-primary transition-colors">
            # /legal
          </Link>
        </div>
        {/* Compact inline newsletter — replaces the big standalone strip
            that used to sit above the link columns. Keeps the footer to a
            single dense bar on desktop. */}
        <div id="newsletter" className="md:ml-auto w-full md:w-auto md:max-w-sm scroll-mt-20">
          <InlineNewsletterSignup />
        </div>
      </div>
    </div>
  );
};

export default FooterLegalBar;
